import { getCategoryName } from 'Pages/Home/Helper/Formatter';
import { TProductCategory } from 'Pages/Home/Helper/Image';
import { TProductData } from 'Pages/Home/Hooks/definitions';
import { useFetchCollectionData } from 'Pages/Home/Hooks/useFetchCollectionData';
import { useGetViewType } from 'Pages/Home/Hooks/useGetViewType';
import React, { useMemo } from 'react';
import KickImage from 'Reuseables/KickImage';
import { useHistory } from 'react-router';
import Spacer from '../../Atoms/Spacer';
import ItemsGrid from '../../Molecules/ItemsGrid';
import Section from '../../Molecules/Section';
import { TProductCollectionSectionProps } from './definitions';
import Styles from './ProductCollectionSection.module.scss';

const ProductCollectionSection: React.FC<TProductCollectionSectionProps> = ({
  className,
  slug,
  category,
  columnCount = 10,
  rowCount = 4,
  columnGap = 44,
  rowGap = 48,
  rowClassName,
  productRowClassname,
  title,
  subtitle,
  actionText = 'View All',
  isPreverified
}) => {
  const { isMobileView } = useGetViewType();
  const { isFetching, data: collectionData } = useFetchCollectionData(
    category,
    slug,
    isMobileView ? 20 : 40,
    isPreverified,
  );

  const defaultData = useMemo(() => {
    const temp: TProductData[] = [];
    const dataLength = isMobileView ? 20 : 40;
    for (let i = 1; i <= dataLength; i++) {
      temp.push({
        id: i,
        name: '',
        slug: '',
        title: '',
        image: '',
        category: category as TProductCategory,
        price: '',
        brand: ''
      });
    }

    return temp;
  }, [isMobileView]);

  const dataNotFound = useMemo(() => {
    return !collectionData || !collectionData?.length;
  }, [collectionData]);

  const wrapperClassName = useMemo(() => {
    return className ? className : Styles['wrapper'];
  }, [className]);

  const onViewAll = () => {
    window.open(`/${getCategoryName(category)}/collection/${slug}`, '_blank');
  };

  const onClickProduct = (product: TProductData) => {
    if (!product.slug) {
      return;
    }
    window.open(
      `/${getCategoryName(product.category)}/${product.brand}/${product.slug}?from=home`,
      '_blank',
    );
  };

  const itemsGridProps = {
    dataSource: dataNotFound || isFetching ? defaultData : collectionData,
    columnCount,
    rowCount,
    columnGap,
    rowGap,
    onPress: (product: TProductData) => onClickProduct(product),
  };

  return (
    <div className={wrapperClassName}>
      <Section
        title={title}
        subTitle={subtitle || ''}
        actionText={actionText}
        rowClassname={rowClassName}
        productRowClassname={productRowClassname}
        onAction={onViewAll}
        withPaddingTitle
      >
        <ItemsGrid {...itemsGridProps} />
      </Section>
    </div>
  );
};

export default ProductCollectionSection;
